// extracted by mini-css-extract-plugin
export default {"ContentBorder":"styles_ContentBorder__g+cqI","dotGrid":"styles_dotGrid__+n2Ke","hangInThere":"styles_hangInThere__oP+Bc","swangin":"styles_swangin__zlT0z"};